import React, { FC } from 'react';
import {
  default as MuiFormControlLabel,
  FormControlLabelProps as MuiFormControlLabelProps
} from '@material-ui/core/FormControlLabel';
import { Uds } from '../../types';

export type FormControlLabelProps = Uds<MuiFormControlLabelProps & {}>;

export const FormControlLabel: FC<React.PropsWithChildren<FormControlLabelProps>> = ({ dataTest, ...props }) => (
  <MuiFormControlLabel data-test={dataTest} {...props} />
);
